import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const foroomtariffApi = api
  .enhanceEndpoints({ addTagTypes: ['FORoomTariff'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFORoomTariffs: builder.query<any[], string>({
        query: cid => `foroomtariff/${cid}`,
        providesTags: ['FORoomTariff']
      }),
      getFORoomTariffDetails: builder.query<any[], string>({
        query: cid => `foroomtariff/details/${cid}`,
        providesTags: ['FORoomTariff']
      }),
      getFORoomTariffById: builder.query<any, string>({
        query: id => `foroomtariff/byid/${id}`,
        providesTags: ['FORoomTariff']
      }),
      insertFORoomTariff: builder.mutation({
        query: foroomtariff => ({
          url: `foroomtariff/`,
          method: 'POST',
          body: foroomtariff
        }),
        invalidatesTags: ['FORoomTariff']
      }),
      updateFORoomTariff: builder.mutation({
        query: foroomtariff => ({
          url: `foroomtariff/`,
          method: 'PUT',
          body: foroomtariff
        }),
        invalidatesTags: ['FORoomTariff']
      }),
      deleteFORoomTariff: builder.mutation({
        query: foroomtariff => ({
          url: `foroomtariff/${foroomtariff.rt_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FORoomTariff']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFORoomTariffsQuery,
  useGetFORoomTariffDetailsQuery,
  useGetFORoomTariffByIdQuery,
  useInsertFORoomTariffMutation,
  useUpdateFORoomTariffMutation,
  useDeleteFORoomTariffMutation
} = foroomtariffApi;

